import { Component } from '@angular/core';

@Component({
  selector: 'app-section-fases',
  templateUrl: './section-fases.component.html',
  styleUrls: ['./section-fases.component.scss'],
})
export class SectionFasesComponent {}
